const Description = ({ children }) => {
  return (
    <div className="text-sm text-[#828282]">
      <p>
        Lorem ipsum dolor sit amet consectetur adipisicing elit. Numquam,
        sapiente illo. Sit error voluptas repellat rerum quidem, soluta enim
        perferendis voluptates laboriosam. Distinctio, officia quis dolore quos
        sapiente tempore alias. Lorem ipsum dolor sit amet Numquam, sapiente
        illo. Sit error voluptas repellat rerum quidem, soluta enim perferendis
        voluptate Distinctio, officia quis dolore quos sapiente tempore alias.
      </p>
    </div>
  );
};

export default Description;
